import {useNavigate, useSearchParams} from "react-router-dom";
import {useGetVehicleQuery, vehicleSelector} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {VehicleProfile} from "../../components/profile/VehicleProfile/VehicleProfile";
import {EntityProfilePage} from "../EntityProfilePage/EntityProfilePage";

type Props = {
  id?: string;
}

export const VehicleProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const {t} = useTranslation()

  const id = params.get("id") ?? undefined;

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage
        message={t("common.entity.vehicle", "Vehicle") + " " + t("common.error.notfound", "Not Found")}/>
    );
  }

  return <VehicleProfilePage id={id}/>;
};

export const VehicleProfilePage = (props: Props) => {
  const {id} = props;

  const [access, setAccess] = useState(false);

  const selectVehicle = useMemo(() => {
    return vehicleSelector()
  }, []);

  const {vehicle, isFetching, error} = useGetVehicleQuery(access ? (id ?? skipToken) : skipToken, {
    selectFromResult: (result) => ({
      vehicle: selectVehicle(result),
      isFetching: result.isFetching,
      error: result.error,
    })
  });

  return (
    <EntityProfilePage
      permissions={["vehicle_view"]}
      entity={vehicle}
      isLoading={isFetching}
      error={error}
      onAccess={setAccess}>
      {(entity) => (
        <VehicleProfile vehicle={entity}/>
      )}
    </EntityProfilePage>
  )
};
